// extracted by mini-css-extract-plugin
export default {"cell":"VirtualTableSelectCell-cell-_Uhr3 VirtualTableRowCell-cell-_Qpcm TableRowCell-cell-giPrj","input":"VirtualTableSelectCell-input-i2Qn8 CheckInput-input-VAM1T"};